var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio-group',{staticClass:"prima",attrs:{"column":false,"dense":""},model:{value:(_vm.selectedOptions),callback:function ($$v) {_vm.selectedOptions=$$v},expression:"selectedOptions"}},_vm._l((_vm.options),function(option,index){return _c('v-radio',{key:index,staticClass:"mr-5",attrs:{"label":option.label,"value":option.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }